var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketPlaceBottomRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 262,
    viewBox: "0 0 260 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_333_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9236 163.994C54.5721 216.435 111.656 244.023 163.424 225.614C215.191 207.205 242.04 149.769 223.392 97.3284C204.743 44.8874 147.659 17.299 95.8915 35.7081C44.1237 54.1172 17.2752 111.553 35.9236 163.994Z",
    fill: "url(#paint0_radial_333_627)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_333_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4911 145.518C76.4514 181.963 115.356 201.41 150.387 188.952C185.418 176.495 203.309 136.852 190.349 100.406C177.389 63.9606 138.484 44.5144 103.453 56.9716C68.4225 69.4289 50.5308 109.072 63.4911 145.518Z",
    fill: "url(#paint1_radial_333_627)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_333_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3801 129.107C99.8602 147.33 119.312 157.053 136.828 150.825C154.343 144.596 163.289 124.774 156.809 106.552C150.329 88.3288 130.877 78.6057 113.361 84.8343C95.8458 91.063 86.8999 110.885 93.3801 129.107Z",
    fill: "url(#paint2_radial_333_627)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_333_627",
    x: 0,
    y: 0,
    width: 259.315,
    height: 261.322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_333_627",
    x: 29.271,
    y: 23.2043,
    width: 195.298,
    height: 199.516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_333_627",
    x: 61.27,
    y: 52.9507,
    width: 127.649,
    height: 129.758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_333_627"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_333_627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.658 130.661) rotate(70.4242) scale(100.778 99.4842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A069A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01FDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_333_627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.92 122.962) rotate(70.4242) scale(70.0387 67.3202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A069A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01FDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_333_627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.095 117.83) rotate(70.4242) scale(35.0194 33.6601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00160247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01FDF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketPlaceBottomRight);
export default __webpack_public_path__ + "static/media/MarketPlaceBottomRight.59d0305959190960092a4f161d6ee282.svg";
export { ForwardRef as ReactComponent };